import React from 'react';
import PropTypes from 'prop-types';
import usePatient from '~/utils/patient/hook';

import { UncontrolledTable } from '~/components';
import ClickToViewModal from '~/components/Patient/Identity/ClickToViewModal';
import { TableFilterIdentitySource } from '~/components/Filters';
import { MatchStatus } from '~/utils/const/identity';

const LinkCell = ({ original }) => (
  <ClickToViewModal>
    <pre style={{ whiteSpace: 'break-spaces' }}>
      {original.attributes.notetext}
    </pre>
  </ClickToViewModal>
);

LinkCell.propTypes = {
  original: PropTypes.shape().isRequired,
};

const Reports = () => {
  const [, { sacwisPersonId: sacwisId }] = usePatient();

  return (
    <UncontrolledTable
      name="abuse-note"
      className="mx-4"
      endpoint={{
        url: 'data/public/list-view-cs-tbl-notes',
        params: {
          sacwis_id: sacwisId,
          notetype: 'Abuse Note',
          match_status_id: MatchStatus.Approved,
        },
      }}
      defaultSorted={[{ id: 'visitdateTs', desc: true }]}
      columns={[{
        id: 'visitdateTs',
        Header: 'Date',
        accessor: 'attributes.visitdateTs',
        cellType: 'date',
      }, {
        id: 'authorname',
        Header: 'Author',
        accessor: 'attributes.authorname',
      }, {
        id: 'authorservice',
        Header: 'Service',
        accessor: 'attributes.authorservice',
      }, {
        id: 'sourceDescription',
        Header: 'Reporting Healthcare Insitution',
        accessor: 'attributes.sourceDescription',
        Filter: d => <TableFilterIdentitySource {...d} />,
      }, {
        id: 'link',
        Header: 'View',
        accessor: 'attributes',
        filterable: false,
        Cell: LinkCell,
      }]}
    />
  );
};

export default Reports;
